import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useProductDetailSection} from '../useGetProductBulkSection';
import {ProductDetailsAccordionsLoading} from './ProductDetailsAccordionsLoading';
import {
  ProductDetailsAccordionProps,
  ProductDetailsAccordionsView,
} from './ProductDetailsAccordionsView';

export const ProductDetailsAccordions: React.FC<
  ProductDetailsAccordionProps
> = props => {
  return (
    <DataFetcher
      request={useProductDetailSection()}
      Error={null}
      Loading={() => (
        <ProductDetailsAccordionsLoading className={props.className} />
      )}
      viewProps={props}
      View={ProductDetailsAccordionsView}
      renderingPriority={props.renderingPriority}
    />
  );
};
